<script>
    import { fly } from "svelte/transition";
    import { Cell,CellGroup,Switch } from '../index'
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body nopadding">
        <CellGroup title="">
            <Cell title="1">
            </Cell>
            <Cell title="2" />
            <Cell title="3" />
        </CellGroup>
    </div>
    <h4 class="example-title">可点击列表</h4>
    <div class="example-body nopadding">
        <CellGroup title="cell组">
            <Cell title="账单">
                desc
            </Cell>
            <Cell title="账单" />
            <Cell title="账单" />
        </CellGroup>
    </div>
    <h4 class="example-title">复杂列表</h4>
    <div class="example-body nopadding">
        <CellGroup title="cell组">
            <Cell title="账单">
                desc
                <svelte:fragment slot="extra">extra</svelte:fragment>
            </Cell>
            <Cell title="账单" clickable={false}>
                desc
                <svelte:fragment slot="extra">
                    <Switch/>
                </svelte:fragment>
            </Cell>
        </CellGroup>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
